import { AbstractPictureState, ILoadState } from "./abstract-picture-state";

export class PictureLoadedState extends AbstractPictureState {
    

    public name: ILoadState = "loaded";

    constructor() {
        super();
    }

    /**
     * @description 设置图片加载完成后的样式
     * 
     */
    public setStyle(): void {}
    
    /**
     * @description 清除当前状态样式,在切换状态前被调用
     * 
     */
    public cleanStyle(): void {}

    
    /**
     * @description 设置当前状态下可用方法,在切换状态后被调用
     * 
     */
    public setAction(): void {}

    public cleanAction(): void {}
}